import { render, staticRenderFns } from "./ActivityItemRow.vue?vue&type=template&id=b01de7be&scoped=true&"
import script from "./ActivityItemRow.vue?vue&type=script&lang=js&"
export * from "./ActivityItemRow.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItemRow.vue?vue&type=style&index=0&id=b01de7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01de7be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VIcon,VImg,VLayout})
